export const validation = {
  email: 'required|email',
  first_name: 'required|min:3|max:50',
  middle_name: 'min:3|max:50',
  last_name: 'required|min:3|max:50',
  second_last_name: 'min:3|max:50',
  phone: 'min:10|numeric',
  phone_verified: '',
  email_verified: '',
  status_id: 'required|numeric|min_value:1|max:1',
  role_id: 'required|numeric|min_value:1|max:1',
  password: 'min:6',
  confirm_password: 'confirmed:password',
  facebook_id: 'numeric|min:6'
}

export const UserFields = function () {
  return {
    email: null,
    first_name: null,
    middle_name: null,
    last_name: null,
    second_last_name: null,
    phone: null,
    phone_verified: null,
    email_verified: null,
    facebook_id: null,
    password: null,
    confirm_password: null,
    status_id: null,
    role_id: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activo'
  },
  {
    id: 2,
    name: 'Inactivo'
  }
]

export const texts = {
  userEdit: {
    title: 'Editar Usuario Existente',
    subtitle: 'Edita la información del usuario, cambia contraseñas, correo, nombre y más',
    submit: 'Actualizar Usuario',
    messages: {
      success: {
        title: 'USUARIO ACTUALIZADO',
        text: 'Este usuario ha sido actualizado correctamente'
      }
    }
  },
  userNew: {
    title: 'Añadir Nuevo Usuario',
    subtitle: 'Crear nuevos usuarios para el administrador, asignales contraseña, correo, entre otros',
    submit: 'Crear Usuario',
    messages: {
      success: {
        title: 'USUARIO CREADO',
        text: 'Se ha creado correctamente el nuevo usuario'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/users/mocks.js